(() => {
  if (customElements.get('vinut-logo-bar')) return;

  class LogoBar extends HTMLElement {
    constructor() {
      super();
      for (const name of ['mount', 'toggle', 'visibility', 'focusIn', 'focusOut', 'selectBlock', 'deselectBlock']) {
        this[name] = this[name].bind(this);
      }
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.mount, { once: true });
      } else {
        this.mount();
      }
    }

    mount() {
      if (!this.isConnected || this.initialized) return;
      this.button = this.querySelector('.vinut-logo-bar__toggle');
      if (!this.button) return;
      this.initialized = true;
      this.button.hidden = false;
      this.button.addEventListener('click', this.toggle);
      this.addEventListener('focusin', this.focusIn);
      this.addEventListener('focusout', this.focusOut);
      document.addEventListener('visibilitychange', this.visibility);
      document.addEventListener('shopify:block:select', this.selectBlock);
      document.addEventListener('shopify:block:deselect', this.deselectBlock);
      this.visibility();
      if ('IntersectionObserver' in window) {
        this.setAttribute('data-offscreen', '');
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) this.toggleAttribute('data-offscreen', !entry.isIntersecting);
        }, { rootMargin: '100px' });
        this.observer.observe(this);
      }
      this.setAttribute('data-ready', '');
    }

    toggle() {
      const paused = this.toggleAttribute('data-user-paused');
      const label = paused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel;
      this.button.setAttribute('aria-label', label);
      this.button.title = label;
    }

    visibility() {
      this.toggleAttribute('data-page-hidden', document.hidden);
    }

    focusIn(event) {
      if (event.target.closest('a') && event.target.matches(':focus-visible')) {
        this.setAttribute('data-keyboard-focus', '');
        event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    focusOut(event) {
      if (!this.contains(event.relatedTarget)) this.removeAttribute('data-keyboard-focus');
    }

    selectBlock(event) {
      this.toggleAttribute('data-editor-selected', this.contains(event.target));
      if (this.contains(event.target)) event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
    }

    deselectBlock() {
      this.removeAttribute('data-editor-selected');
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.mount);
      if (!this.initialized) return;
      this.observer?.disconnect();
      this.button.removeEventListener('click', this.toggle);
      this.removeEventListener('focusin', this.focusIn);
      this.removeEventListener('focusout', this.focusOut);
      document.removeEventListener('visibilitychange', this.visibility);
      document.removeEventListener('shopify:block:select', this.selectBlock);
      document.removeEventListener('shopify:block:deselect', this.deselectBlock);
      this.initialized = false;
    }
  }

  customElements.define('vinut-logo-bar', LogoBar);
})();
